import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function OtpDisplay({ otpText }) {
    const numbers = otpText ? otpText.toString().split('') : [];

    return (
        <Box
            sx={{
                width: '70%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            {numbers.map((num, i) => (
                <Typography
                    variant="h5"
                    sx={{
                        borderStyle: 'solid',
                        borderColor: 'rgba(255,255,255,0.35)',
                        borderWidth: 0.5,
                        borderRadius: 1,
                        backgroundColor: 'rgba(0,44,27,0.9)',
                        width: 55,
                        height: 55,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: 'white',
                        fontSize: 28,
                        fontFamily: 'Roboto',
                    }}
                    key={i}
                >
                    {num}
                </Typography>
            ))}
        </Box>
    );
}
